module.exports = __webpack_public_path__ + "static/index/img/baikal-602.a3afbb85.jpg";